@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.mobileupdate

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.MobileUpdateConfigDto

object UpsertMobileUpdateConfigEndpoint : EndPoint<UpsertMobileUpdateConfigEndpoint.Request, UpsertMobileUpdateConfigEndpoint.Response>() {
    class Request(val config: MobileUpdateConfigDto)
    class Response()
}
